var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('FormulateInput',{staticClass:"mb-3 small",attrs:{"name":"b2bAlumniInput","type":"checkbox","data-action":"b2bAlumniInput"},scopedSlots:_vm._u([{key:"label",fn:function({ id }){return [_c('label',{staticClass:"ml-2",attrs:{"for":id}},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.$t('b2bAlumniInput'))+"\n\t\t\t")])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }